import { ON_CLICK } from '../constants';

const getClickWrapperOptions = (children = {}, componentProps = {}, id = null) => {
  let shouldUseClickWrapper = false;

  const { props: { children: childComponents = [] } = {} } = children || {};
  if (!childComponents || !childComponents[1]) return { shouldUseClickWrapper, wrapperProps: {} };

  const clickEvents = childComponents[1]
    .map(child => {
      const { props: { component: { settings: { gtmEvents } = {} } = {} } = {} } = child || {};
      if (!gtmEvents) return null;

      return gtmEvents.find(({ eventTrigger }) => eventTrigger === ON_CLICK);
    })
    .filter(Boolean);

  shouldUseClickWrapper = !!clickEvents && !!clickEvents.length;

  const wrapperProps = shouldUseClickWrapper
    ? { gtmChildren: children, ...componentProps, id }
    : {};

  return { shouldUseClickWrapper, wrapperProps };
};

export default getClickWrapperOptions;
